<template lang="pug">
div
  section.u-mt-md
    AppTitle.u-mb-0(:title="$t('mantra')")

  section.u-mt-md
    .grid.is-tablet-6.is-widescreen-4
      .column.u-mb-sm(v-for="item,idx in $t('sec1Items')")
        h4 {{item.title}}
        p {{item.desc}}

  section.u-mt-md
    .grid
      .column.is-widescreen-5
        AppTitle.u-mb-mi(:title="$t('sec2')" tag="h2")
      .column.is-widescreen-7
        .grid.is-tablet-6
          .column.u-mb-sm(v-for="item,idx in $t('sec2Items')")
            h4 {{item.title}}
            p {{item.desc}}

  section.u-mt-md
    .grid
      .column.is-widescreen-5
        AppTitle.u-mb-mi(:title="$t('sec3')" tag="h2")
      .column.is-widescreen-7
        .grid.is-tablet-6
          .column.u-mb-sm(v-for="item,idx in $t('sec3Items')")
            h4 {{item.title}}
            p {{item.desc}}

  section.u-mt-md
    .grid.is-tablet-6
      .column.u-mb-sm(v-for="item,idx in $t('sec4Items')")
        h4 {{item.title}}
        p.u-mb-ts {{item.desc}}
        AppLink(v-if="item.url" :to="item.url" :title="$t('learnMore')" class="button-link is-small") {{$t('learnMore')}}

  section.u-mt-md.u-mb-md
    AppLink(to="/ordering" :title="$t('cta')" class="button-link is-large " v-html="$t('cta')")

</template>

<script>
export default {
  head() {
    const $t = this.$t.bind(this);
    return {
      title: $t('pageTitle'),
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          property: 'og:title',
          content: $t('pageTitle')
        },
        {
          hid: 'description',
          name: 'description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:image',
          name: 'og:image',
          property: 'og:image',
          content: 'https://cdn.baianat.com/static/share/services.png'
        },
        {
          hid: 'twitter:image',
          name: 'twitter:image',
          property: 'twitter:image',
          content: 'https://cdn.baianat.com/static/share/services.png'
        }
      ]
    };
  }
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"Retail and ecommerce",
    "pageDesc":"Designing and developing ecommerce websites whether native, or using a framework like magento or opencart.",
    "mantra":"Build your online |ecommerce store.",
    "sec1Items":{
      "1":{
        "title":"Ecommerce application development",
        "desc":"Be closer to your customers and increase your database through an iOS or Android application that lets them order anytime and communicates your offerings through push notifications."
      },
      "2":{
        "title":"Ecommerce website design",
        "desc":"Develop an Amazon alike store or move your current brand into the digital world. Whether fashion, electronics or ecommerce, we help you spread awareness about your brand."
      },
      "3":{
        "title":"Support and maintenance",
        "desc":"Securing your website against crashes, cyber attacks and data leaks. Upgrading it regularly to the latest technology practices and working on issues when arise."
      },
      "4":{
        "title":"Ecommerce plugin and module development",
        "desc":"Developing custom plugins to power up your ecommerce store. From email campaigns, to live chat and other features that your sellersa might need."
      },
      "5":{
        "title":"Ecommerce payment gateway integration",
        "desc":"Effective gateway integration services like Authorize.net, Paypal, Stripe, BitCoin, Etc, which will help you in managing and processing online transactions."
      }
    },
    "sec2":"Have a professional presence.",
    "sec2Items":{
      "1":{
        "title":"Technical SEO",
        "desc":"Optimizing your website for the search engines according to the best practices  to rank higher and drive more traffic to and build a fanbase."
      },
      "2":{
        "title":"Informative admin",
        "desc":"Providing you with a clean admin panel through which you can track orders, communicate with customers and generate business reports."
      },
      "3":{
        "title":"Customizable features",
        "desc":"Each store has a different. We custom our features to suit your unique business needs. From down payment features to 360° product view."
      },
      "4":{
        "title":"Custom URLs and product ",
        "desc":"With custom link features, make sure you never lose any of your store links when the product is not available and reduce your 404 rate."
      }
    },
    "sec3":"From analysis to execution.",
    "sec3Items":{
      "1":{
        "title":"Planning and analysis",
        "desc":"Discerning the store industry, defining the requirements and planning the features necessary and the execution time needed."
      },
      "2":{
        "title":"Interface design",
        "desc":"Creating a user friendly interface following the UX guidelines of eCommerce and supporting it with microinteractions and UI animations."
      },
      "3":{
        "title":"Development",
        "desc":"Whether native development, Magento or Opencart, we develop a store using clean code and supporting all the necessary functions. "
      },
      "4":{
        "title":"Testing",
        "desc":"Conducting performance, function and other types of tests We then pack and deliver the final project to you for your own assessment."
      },
      "5":{
        "title":"Delivery",
        "desc":"Gathering your feedback, going through iteration and launching the store. Keeping the optimization running and fixing issues whenever arise."
      }
    },
    "sec4Items":{
      "1":{
        "title":"Opencart",
        "desc":"Leverage on opencart easy backend development and build your store today.",
        "url":"/solutions/opencart"
      },
      "2":{
        "title":"Magento",
        "desc":"Start from the Magento open source framework and customize until you reach the desired look and functionality.",
        "url":"/solutions/magento"
      }
    },
    "cta":"Open your online <br> store now."
  },
  "ar": {
    "pageTitle":"تصميم وبرمجة المتاجر الإلكترونية",
    "pageDesc":"نعمل على تصميم وتطوير مواقع التجارة الإلكترونية سواء كانت مخصصة أو باستخدام قوالب مثل ماجنتو أو اوبن كارت.",
    "mantra":"حلول وأفكار لتصميم |وبرمجة المتاجر الإلكترونية.",
    "sec1Items":{
      "1":{
        "title":"برمجة تطبيقات المتاجر",
        "desc":"كن بالقرب من عملائك واعمل على زيادة قاعدة البيانات الخاصة بك من خلال تطبيق أي أو إس أو أندرويد حيث من خلالهما يمكن لأي مستخدم طلب الخدمة في أي وقت ومعرفة عروضك من خلال الإشاعات."
      },
      "2":{
        "title":"تصميم مواقع المتاجر",
        "desc":"قم بتطوير متجر يتشابه مع متجر أمازون أو انقل علامتك التجارية التجارية إلى العالم الرقمي. سواء كنت تمتلك متجرًا للأزياء أو الإلكترونيات ...وغيره سوف نساعدك على نشر الوعي حول علامتك التجارية."
      },
      "3":{
        "title":"الدعم والصيانة",
        "desc":"سوف نساعدك دائمًا في تأمين موقعك ضد أي أعطال أو هجمات إلكترونية أو تسريب في البيانات، من خلال اتباع أحدث الممارسات والوسائل لاكتشاف المشكلات والعمل على حلها فور ظهورها."
      },
      "4":{
        "title":"الإضافات الخاصة بالمتاجر",
        "desc":"يمكنك الاستفادة من تطوير الإضافات المخصصة بمتجرك بداية من حملات البريد الإلكتروني والدردشة الحية والمميزات الآخرى التي يحتاجها البائعين الموجودين على متجرك."
      },
      "5":{
        "title":"تكامل بوابة الدفع للمتجر",
        "desc":"تسطتيع الإعتماد على خدمات تكامل بوابة الدفع الفعالة مثل Authorize.net ، و باي بال، و سترايب، و بيتكوين..وغيرها والتي ستساعدك في إدارة المعاملات عبر الإنترنت."
      }
    },
    "sec2":"وفر لعملائك تجربة تسوق ممتعة.",
    "sec2Items":{
      "1":{
        "title":"تقنيات السيو",
        "desc":"نعمل على تحسين متجرك من خلال أفضل الممارسات ليتناسب مع محركات البحث من أجل ترتيب أفضل وزيادة عدد الزيارات وبناء المزيد من العملاء."
      },
      "2":{
        "title":"لوحة الأدمن",
        "desc":"سوف نزودك بلوحة الأدمن الواضحة حيث يمكنك من خلالها تتبع الطلبات والتواصل مع العملاء وإنشاء تقارير عملك بسهولة."
      },
      "3":{
        "title":"مميزات قابلة للتخصيص",
        "desc":"كل متجر لديه مميزات مختلفة تختلف عن أي متجر آخر. نخصص مميزاتنا لتناسب احتياجات عملك وكذلك جمهورك المستهدف، من مميزات الدفع حتى عرض المنتجات بطريقة 360 درجة."
      },
      "4":{
        "title":"عنوان URLs والمنتجات ",
        "desc":"نمنحك مميزات الارتباط المخصصة، تأكد أنه لن يتم فقد أي من روابط متجرك في حالة عدم توفر المنتج وتقليل معدل 404 الخاص بك."
      }
    },
    "sec3":"من التحليل إلى التنفيذ",
    "sec3Items":{
      "1":{
        "title":"التخطيط والتحليل",
        "desc":"نفهم احتياجات عملك ونحدد المتطلبات ثم نخطط كيفية إنتاج هذه المميزات ووقت التنفيذ اللازم لها من أجل المزيد من الإنتاجية."
      },
      "2":{
        "title":"تصميم واجهة المستخدم",
        "desc":"نعمل على إنشاء واجهة سهلة الاستخدام باتباع إرشادات تجربة المستخدم الخاصة بالمتاجر الإلكترونية ودعمها بالتفاعلات الدقيقة التي يقوم بها المستخدم ورسوم الواجهة."
      },
      "3":{
        "title":"البرمجة",
        "desc":"سواء كانت برمجة مخصصة أو ماجنتو أو اوبن كارت، لهذا نقوم بتطوير المتجر باستخدام أكواد واضحة لندعم  جميع الوظائف الضرورية."
      },
      "4":{
        "title":"اختبارات",
        "desc":"نعمل على إجراء الاختبارات المختلفة من حيث إختبارات الأداء والوظائف، والأنواع الأخرى من الاختبارات، نقوم بعد ذلك بإنهاء المشروع وتقديمه لك."
      },
      "5":{
        "title":"إطلاق المتجر",
        "desc":"نقوم بجمع ملاحظاتك ومن خلال المراجعات المستمرة نعمل على تحسين المتجر من أجل إطلاقه بالشكل النهائى الكامل."
      }
    },
    "sec4Items":{
      "1":{
        "title":"أوبن كارت",
        "desc":"يمكنك بناء متجرك والاستفادة من الأوبن كارت الذي يتميز بسهولة تطوير الواجهة الخلفية الخاصة به.",
        "url":"/solutions/opencart"
      },
      "2":{
        "title":"الماجنتو",
        "desc":"سوف يساعدك الماجنتو على بناء متجرك بالصورة التي تحلم منها من خلال الاستفادة بمزايا الماجنتو المتعددة. ",
        "url":"/solutions/magento"
      }
    },
    "cta":"افتح متجرك الالكتروني الآن"
  }
}
</i18n>
